import {DocumentService, iterateAncestors} from "@buildwithflux/core";
import {AnyPcbBakedNode, NodeUid, PcbBakedNode, PcbNodesMap, PcbNodeTypes} from "@buildwithflux/models";
import {pickBy} from "lodash";

/**
 * Get all locked ancestors of a node.
 * Returns an array of ancestor nodes that have locked=true, ordered from nearest to farthest.
 * This is used to display which ancestors are locking a node and to unlock them.
 */
export function getLockedAncestors(documentService: DocumentService, nodeUid: NodeUid): AnyPcbBakedNode[] {
    const allBakedNodes = documentService.snapshot().pcbLayoutNodes;
    const node = allBakedNodes[nodeUid];
    if (!node) {
        return [];
    }

    const lockedAncestors: AnyPcbBakedNode[] = [];
    for (const ancestor of iterateAncestors(node, allBakedNodes)) {
        if (ancestor.locked) {
            lockedAncestors.push(ancestor);
        }
    }
    return lockedAncestors;
}

// TODO: consider moving this module to new file: frontend/src/helpers/pcb.ts

export function getAllBakedNodes(documentService: DocumentService) {
    return documentService.snapshot().pcbLayoutNodes;
}

export function getAllActiveBakedNodes(documentService: DocumentService) {
    const {pcbLayoutNodes} = documentService.snapshot();
    return pickBy(pcbLayoutNodes, (node) => node.bakedRules.active);
}

export function getBakedNode(documentService: DocumentService, nodeUid: NodeUid) {
    const {pcbLayoutNodes} = documentService.snapshot();

    return pcbLayoutNodes[nodeUid];
}

export function getTypedBakedNode<T extends PcbNodeTypes>(documentService: DocumentService, nodeUid: NodeUid, type: T) {
    const node = getBakedNode(documentService, nodeUid);

    if (node?.type === type) {
        return node as PcbBakedNode<T>;
    } else {
        return undefined;
    }
}

export function getTypedBakedNodeFromMap<T extends PcbNodeTypes>(
    pcbLayoutNodes: PcbNodesMap<AnyPcbBakedNode>,
    nodeUid: NodeUid,
    type: T,
) {
    const node = pcbLayoutNodes[nodeUid];

    if (node?.type === type) {
        return node as PcbBakedNode<T>;
    } else {
        return undefined;
    }
}
